import classnames from "classnames"

export type HeadingSize = "2xl" | "xl" | "lg" | "md" | "sm" | "xs" | "2xs"

export interface HeadingProps {
  children: React.ReactNode
  /** Overrides the default styles. (eg. "mb-2 mr-1" for margin) */
  className?: string
  /** Selects an h1-h5 HTML element and a default size. */
  level: 1 | 2 | 3 | 4 | 5
  /** Overrides heading size with a style preset. */
  size?: HeadingSize
}

const DEFAULT_SIZE_BY_LEVEL: Record<HeadingProps["level"], HeadingSize> = {
  1: "lg",
  2: "md",
  3: "sm",
  4: "xs",
  5: "2xs",
}

export const Heading = ({ children, className, level, size }: HeadingProps) => {
  const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements
  const resolvedSize = size || DEFAULT_SIZE_BY_LEVEL[level]

  return (
    <HeadingTag
      className={classnames(
        "dds-heading",
        `dds-heading--${resolvedSize}`,
        className,
      )}
    >
      {children}
    </HeadingTag>
  )
}
